import { wasHeaderModalVisible } from '../actions/AppHeaderModalActions';

const SearchState = (
  currentState = {
    isSearchVisible: wasHeaderModalVisible('SHOW_SEARCH'),
    query: undefined,
    searchedWords: [],
    searchData: []
  },
  action
) => {
  switch (action.type) {
    case 'RESET_SEARCH_DATA':
      return {
        ...currentState,
        query: undefined,
        searchedWords: [],
        searchData: []
      };
    case 'UPDATE_SEARCH_DATA':
      return {
        ...currentState,
        searchData: action.searchData
      };
    case 'SEARCH_WORDS':
      return {
        ...currentState,
        searchedWords: action.searchedWords
      };
    case 'SEARCH_QUERY':
      return {
        ...currentState,
        query: action.query
      };
    case 'SHOW_SEARCH':
      return {
        ...currentState,
        isSearchVisible: true
      };
    case 'HIDE_SEARCH':
      return {
        ...currentState,
        isSearchVisible: false
      };
    case 'CLOSE_MODAL':
      return {
        ...currentState,
        isSearchVisible: false
      };
    default:
      return currentState;
  }
};
export default SearchState;
